import type { Extras } from '@sentry/core'
import * as Sentry from '@sentry/react'

import {
  NotFoundError,
  StandardError,
  StandardRestError,
} from '@/modules/errors'
import { isPageUnloading } from '@/utils'

const handledErrors = [NotFoundError]

export const captureException = (
  error: Error,
  componentStack?: string | null,
  ownerStack?: string | null,
) => {
  if (isPageUnloading()) return

  let standardError: StandardError
  if (error instanceof StandardError) {
    standardError = error
  } else {
    standardError = new StandardError(error.message)
    standardError.stack = error.stack
  }

  console.log(standardError, componentStack, ownerStack)
  const isHandledError = handledErrors.some(
    (ErrorClass) => standardError instanceof ErrorClass,
  )
  if (isHandledError) return

  Sentry.withScope((scope) => {
    const extras: Extras = {}

    if (standardError instanceof StandardRestError) {
      scope.setTag('request_type', 'rest')
    }

    extras.body = standardError.body
    extras.status = standardError.status
    scope.setExtras(extras)
    if (componentStack || ownerStack) {
      scope.setContext('react', { componentStack, ownerStack })
    }
    scope.captureException(error)
  })
}
